const NAMESPACE = "projectTable";

const KEYS = {
    configurationErrorTitle: "configurationErrorTitle",
    noFormConfiguredMessage: "noFormConfiguredMessage",
    channelNotLinkedMessage: "channelNotLinkedMessage",
    channelNotEnabledMessage: "channelNotEnabledMessage",
    projectNotFoundMessage: "projectNotFoundMessage",
    viewText: "viewText",
    importNewProjectsButtonLabel: "importNewProjectsButtonLabel",
    removeRowConfirmationMessage: "removeRowConfirmationMessage",
    currentStatusHeader: "currentStatusHeader",
    addExistingProjectButtonLabel: "addExistingProjectButtonLabel"
};

const MESSAGES = {
    [KEYS.configurationErrorTitle]: {
        value: "Configuration Error",
        comment: "Title for the configuration error dialog"
    },
    [KEYS.noFormConfiguredMessage]: {
        value: "Channel does not have a form configured.",
        comment: "Message for the configuration error dialog when the channel does not have a form"
    },
    [KEYS.channelNotLinkedMessage]: {
        value: "Channel not linked.",
        comment: "Message for the configuration error dialog when the channel is not linked"
    },
    [KEYS.channelNotEnabledMessage]: {
        value: "Channel not enabled.",
        comment: "Message for the configuration error dialog when the channel is not enabled"
    },
    [KEYS.projectNotFoundMessage]: {
        value: "Unable to find the related project. It may have been deleted.",
        comment: "Message for the error dialog when we can't find a project on the other end of the relation"
    },
    [KEYS.viewText]: {
        value: "View",
        comment: "Text for the button that views the project"
    },
    [KEYS.importNewProjectsButtonLabel]: {
        value: "Import New Projects",
        comment: "Label for a button that imports new projects to a project table"
    },
    [KEYS.removeRowConfirmationMessage]: {
        value: "Are you sure you want to remove this row?",
        comment: "Text for the project row confirmation box"
    },
    [KEYS.currentStatusHeader]: {
        value: "Current Status",
        comment: "Header for the current status column of the project table"
    },
    [KEYS.addExistingProjectButtonLabel]: {
        value: "Add Existing Project",
        comment: "Label for a button that adds an existing project to the project table"
    }
};

export { KEYS, NAMESPACE, MESSAGES };
